var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgEngineRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_28_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 285 263",
    style: {
      enableBackground: "new 0 0 285 263"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;}\n\t.st1{opacity:0.8;fill:url(#Path_671_00000065780316447904556480000003360170457531983283_);enable-background:new    ;}\n\t.st2{fill:#757575;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{opacity:0.7;fill:url(#Ellipse_111_00000071554542943695671690000005352944306553463716_);enable-background:new    ;}\n\t.st5{fill:#ACACAC;}\n\t.st6{fill:#D8D8D8;}\n\t.st7{fill:#6D6D6D;}\n\t.st8{fill:#828282;}\n\t.st9{fill:#545454;}\n\t.st10{fill:#595959;}\n\t.st11{fill:#3D3D3D;}\n\t.st12{fill:#464646;}\n\t.st13{fill:#3B3B3B;}\n\t.st14{fill:#B1B1B1;}\n\t.st15{fill:#C2C2C2;}\n\t.st16{fill:#848484;}\n\t.st17{fill:#878787;}\n\t.st18{fill:#F3F3F3;}\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 285,
    height: 133,
    id: "Path_786_00000165209584579537060490000012870248648284832412_",
    xlinkHref: "718C0D6D1A575B79.png",
    transform: "matrix(1 0 0 1 0 117)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    transform: "translate(-347.596 -103.58)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_502"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_671_00000158734407402507968620000011985888713448471215_",
    gradientUnits: "userSpaceOnUse",
    x1: -465.5386,
    y1: 774.6119,
    x2: -465.5386,
    y2: 773.6119,
    gradientTransform: "matrix(242.767 0 0 -206.795 113507.9141 160312.0469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.081,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.855
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.631
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.439
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.282
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.157
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.071
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.02
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    style: {
      opacity: 0.8,
      fill: "url(#Path_671_00000158734407402507968620000011985888713448471215_)",
      enableBackground: "new"
    },
    d: " M611.9,333H369.1l47.8-206.8h145.3L611.9,333z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_465",
    className: "st2",
    d: "M416.1,114h146.7c1.4,0,2.5,1.1,2.5,2.5v3.9c0,1.4-1.1,2.5-2.5,2.5H416.1 c-1.4,0-2.5-1.1-2.5-2.5v-3.9C413.6,115.1,414.7,114,416.1,114z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_466",
    className: "st2",
    d: "M423.1,103.6h2.6c0.4,0,0.8,0.4,0.8,0.8v9.9c0,0.4-0.4,0.8-0.8,0.8h-2.6 c-0.4,0-0.8-0.4-0.8-0.8v-9.9C422.3,103.9,422.6,103.6,423.1,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_467",
    className: "st2",
    d: "M465.6,103.6h2.6c0.4,0,0.8,0.4,0.8,0.8v9.9c0,0.4-0.4,0.8-0.8,0.8h-2.6 c-0.4,0-0.8-0.4-0.8-0.8v-9.9C464.8,103.9,465.2,103.6,465.6,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_468",
    className: "st2",
    d: "M508.2,103.6h2.6c0.4,0,0.8,0.4,0.8,0.8v9.9c0,0.4-0.4,0.8-0.8,0.8h-2.6 c-0.4,0-0.8-0.4-0.8-0.8v-9.9C507.4,103.9,507.7,103.6,508.2,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_469",
    className: "st2",
    d: "M550.8,103.6h2.6c0.4,0,0.8,0.4,0.8,0.8v9.9c0,0.4-0.4,0.8-0.8,0.8h-2.6 c-0.4,0-0.8-0.4-0.8-0.8v-9.9C550,103.9,550.3,103.6,550.8,103.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_470",
    className: "st3",
    d: "M416.9,121.1h145.3c0.8,0,1.5,0.7,1.5,1.5v2.1c0,0.8-0.7,1.5-1.5,1.5H416.9 c-0.8,0-1.5-0.7-1.5-1.5v-2.1C415.4,121.8,416.1,121.1,416.9,121.1z"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Ellipse_111_00000152981190329173754290000011464243037587653775_",
    cx: -455.9708,
    cy: 748.0036,
    r: 1.972,
    gradientTransform: "matrix(63.1706 0 0 -14.4962 29292.9668 11174.5059)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.984
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.937
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.855
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.745
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.42
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.216
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_111",
    style: {
      opacity: 0.7,
      fill: "url(#Ellipse_111_00000152981190329173754290000011464243037587653775_)",
      enableBackground: "new"
    },
    cx: 490.8,
    cy: 335,
    rx: 132.2,
    ry: 31.7
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    transform: "translate(-596.787 -104.338)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    className: "st5",
    cx: 703.4,
    cy: 223.5,
    r: 40.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_446"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    className: "st6",
    d: "M707.4,182.9c-3.8,5.5-13.8,20-20.3,29.7c-6.5,9.9-16.3,24.7-19.8,30.1 c2.6,4.8,6.1,9.1,10.3,12.5c4.2-6.9,12.4-20.4,19.5-30.9c8-12,20-30.5,24.4-37.4C717.1,184.7,712.3,183.4,707.4,182.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    className: "st6",
    d: "M693.2,184L663,229.5c0.4,2.5,1,5,1.8,7.4c4.1-7.1,14.2-24.3,18.1-30.2 c3.9-5.8,12.6-18.2,16.5-23.7C697.3,183.1,695.2,183.5,693.2,184z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    transform: "translate(-596.787 -104.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    className: "st7",
    d: "M653.6,262.2c-0.2-2.1,0-9.9,0-12.2s1-4.2,6.3-5.7c5.3-1.5,28.4-8.2,42.2-9.7 c13.7-1.6,25-2.4,35.2-2c10.2,0.4,17.3,6.1,22,16.2c4.8,10.1,5,16.8-12.5,18c-17.6,1.2-57.9,0.3-68.6-0.1S654,266.7,653.6,262.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    className: "st8",
    d: "M659.9,244.3c-5.3,1.5-6.3,3.4-6.3,5.7v0.1c4.5-0.8,9.7-1.3,12.8,1.6c4,3.6,7.1,11.2,7.1,11.2 c1.8-3.9-1.4-13.1-5-15.1c1.1-0.5,2.5-0.9,4-1.4c4.9,3.6,8.5,8.8,10.2,14.7c3.8-4.2-1.3-12.3-4.6-16.2c1.2-0.3,2.6-0.6,3.9-1 c2.9,1.6,5.2,3.9,6.9,6.7c1.8,2.9,3.1,6.1,3.9,9.5c2.6-4.4,0.4-12.5-5.5-17.4c1.9-0.4,3.9-0.8,5.9-1.2c2.7,1.8,5,4.3,6.6,7.2 c1.8,3.4,3.4,7,4.6,10.7c2.9-5.2-1.1-14.1-5.9-18.9c1.4-0.2,2.9-0.4,4.4-0.6c2.4,2.5,4.6,5.2,6.4,8.2c2.6,4,5.4,11.9,5.4,11.9 c3.8-5.1-1.8-16-6-20.8c1.5-0.1,3.1-0.3,4.6-0.4c2.3,2.4,4.2,5.1,5.8,8c2.2,3.7,5.1,12.2,5.1,12.2c3.7-4.2-1.1-15.1-6.4-20.5 c2.5-0.1,5.1-0.1,7.6-0.1c2.7,2.2,4.9,4.8,6.7,7.8c2.3,4,4.2,8.2,5.6,12.6c1.5-5-0.8-13.9-5.9-20.3c2.5,0.1,5.1,0.2,7.6,0.4 c4.1,6.2,8.4,14.9,9.4,18.8c1.8-6.3-1.7-13.8-4.4-18.4c3.7,0.3,7,0.7,9.5,1.2c-4.2-4.8-10.2-7.7-16.6-7.8 c-10.2-0.4-21.5,0.4-35.2,2C688.3,236.1,665.2,242.8,659.9,244.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    className: "st9",
    d: "M672.3,252.6c0,0,3,7.4,3.4,14c0.9,0,1.7,0.1,2.5,0.1c0.4,0,0.9,0,1.5,0.1 C678.3,259,675.3,253.8,672.3,252.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    className: "st9",
    d: "M737.4,247c2.2,3.3,4.7,12.3,5.7,20.1c1.4-0.1,2.6-0.1,3.8-0.2c0.2,0,0.4,0,0.6-0.1 C746.6,261.9,744.3,252.3,737.4,247z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    className: "st9",
    d: "M714.2,267.4c-1.2-6.8-4.8-15.8-9.6-18.1c2.8,5.3,4.7,13.9,5.5,18.1 C711.5,267.4,712.8,267.4,714.2,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    className: "st9",
    d: "M743.8,234.3c2.9,1.8,7.7,8.8,10.6,14.3c2.9,5.6,3.1,10.3,1.4,13.5c-0.5-1.9-2.9-9.7-6.9-14.2 c1.9,3.7,2.8,11.5,3.1,18.3c12.2-2.2,11.6-8.5,7.3-17.4c-3.8-8.1-9.2-13.4-16.5-15.3C743.1,233.8,743.5,234.1,743.8,234.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    className: "st9",
    d: "M697.6,267.2c1.4,0,2.8,0,4.3,0.1c-1-6.9-3.5-14.9-8.3-17.9 C695.9,255.1,697.3,261.1,697.6,267.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    className: "st9",
    d: "M721.4,267.4c1.8,0,3.5,0,5.2,0c-2.1-7.5-7.3-16.5-11.7-18.3 C718,253.8,720.3,261.1,721.4,267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    className: "st9",
    d: "M690.9,267.1c-0.9-6.2-3.8-15-8.5-15.7c2.2,3,4.1,10,4.8,15.7C688.4,267,689.6,267,690.9,267.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    className: "st9",
    d: "M724.2,247.9c2.9,5.3,4.4,9.5,6.6,19.5c1.6,0,3.2,0,4.7-0.1 C733.7,260.9,729.5,248.9,724.2,247.9z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    transform: "translate(-596.787 -104.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    className: "st5",
    d: "M680.5,242.6c5.7-1.6,11.4-2.7,17.3-3.2c5.8-0.5,11.7-0.5,17.6-0.5c8.7,0,17.5-0.6,26.2-1 c8-21.1-2.7-44.6-23.8-52.6c-21.1-8-44.6,2.7-52.6,23.8c-4.6,12.2-3.1,25.8,4,36.7C673,244.8,676.7,243.6,680.5,242.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    className: "st6",
    d: "M680.5,242.6c1.9-0.5,3.8-1,5.8-1.4c3.5-5.6,7.3-11.6,10.8-16.9c8-12,20-30.5,24.4-37.4 c-4.4-2.2-9.2-3.5-14.1-4c-3.8,5.5-13.8,20-20.3,29.7c-6.5,9.9-16.3,24.7-19.8,30.1c0.6,1.1,1.2,2.1,1.8,3.1 C673,244.8,676.7,243.6,680.5,242.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    className: "st6",
    d: "M693.2,184L663,229.5c0.4,2.5,1,5,1.8,7.4c4.1-7.1,14.2-24.3,18.1-30.2 c3.9-5.8,12.6-18.2,16.5-23.7C697.3,183.1,695.2,183.5,693.2,184z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    transform: "translate(-596.787 -104.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_420",
    className: "st2",
    d: "M644.5,286.8h198.9c0.7,0,1.3,0.6,1.3,1.3v46.4c0,0.7-0.6,1.3-1.3,1.3H644.5 c-0.7,0-1.3-0.6-1.3-1.3v-46.4C643.2,287.4,643.8,286.8,644.5,286.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    className: "st10",
    d: "M843.4,286.8H644.5c-0.7,0-1.3,0.6-1.3,1.3c0,0,0,0,0,0v9.9h201.4v-9.9 C844.6,287.4,844.1,286.8,843.4,286.8C843.4,286.8,843.4,286.8,843.4,286.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_421",
    className: "st2",
    d: "M639.6,266.2h206.1c6.4,0,11.5,5.2,11.5,11.5v1.5c0,6.4-5.2,11.5-11.5,11.5H639.6 c-6.4,0-11.5-5.2-11.5-11.5v-1.5C628.1,271.4,633.2,266.2,639.6,266.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96",
    className: "st10",
    cx: 640.6,
    cy: 278.6,
    r: 6.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_97",
    className: "st10",
    cx: 844.8,
    cy: 278.6,
    r: 6.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    className: "st10",
    d: "M845.7,269H639.6c-4.8,0-8.7,3.9-8.7,8.7v1.5c0,4.8,3.9,8.7,8.7,8.7h206.1 c4.8,0,8.7-3.9,8.7-8.7v-1.5C854.4,272.9,850.5,269,845.7,269z M852.4,279.3c0,3.7-3,6.7-6.7,6.7H639.6c-3.7,0-6.7-3-6.7-6.7v-1.5 c0-3.7,3-6.7,6.7-6.7h206.1c3.7,0,6.7,3,6.7,6.7V279.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    className: "st11",
    cx: 640.6,
    cy: 278.6,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    className: "st11",
    cx: 844.8,
    cy: 278.6,
    r: 3.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_452"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_422",
    x: 653.5,
    y: 272.3,
    className: "st10",
    width: 1.2,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_423",
    x: 676.4,
    y: 272.3,
    className: "st10",
    width: 1.2,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_424",
    x: 699.4,
    y: 272.3,
    className: "st10",
    width: 1.2,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_425",
    x: 722.3,
    y: 272.3,
    className: "st10",
    width: 1.2,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_426",
    x: 745.3,
    y: 272.3,
    className: "st10",
    width: 1.2,
    height: 12
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    className: "st11",
    d: "M845.7,271H639.6c-3.7,0-6.7,3-6.7,6.7v1.5c0,3,2,5.7,4.9,6.5c-1.6-1.1-2.6-2.7-2.8-4.6 c-0.2-0.7-0.2-1.5-0.1-2.2v-1.2c0-2.6,2.1-4.7,4.7-4.7h206.1c2.6,0,4.7,2.1,4.7,4.7v1.5c0,1.5-0.5,2.9-1.5,4.1 c-0.3,1-1.2,1.6-1.7,2.5c3-0.7,5.2-3.4,5.2-6.5v-1.5C852.4,274,849.4,271,845.7,271z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    transform: "translate(-596.787 -104.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_455"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_427",
    className: "st12",
    d: "M782.5,160.5h4.8c2.8,0,5.1,2.3,5.1,5.1c0,0,0,0,0,0v3.8l0,0h-14.9l0,0v-3.8 C777.4,162.7,779.7,160.5,782.5,160.5C782.5,160.5,782.5,160.5,782.5,160.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_428",
    className: "st10",
    d: "M776.9,167.4h16.1c1.2,0,2.2,1,2.2,2.2c0,0,0,0,0,0v4.9l0,0h-20.4l0,0v-4.9 C774.7,168.3,775.7,167.4,776.9,167.4C776.9,167.4,776.9,167.4,776.9,167.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_429",
    className: "st13",
    d: "M811.6,160.5h4.8c2.8,0,5.1,2.3,5.1,5.1c0,0,0,0,0,0v3.8l0,0h-14.9l0,0v-3.8 C806.6,162.7,808.8,160.5,811.6,160.5C811.6,160.5,811.6,160.5,811.6,160.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_430",
    className: "st10",
    d: "M806,167.4h16.1c1.2,0,2.2,1,2.2,2.2c0,0,0,0,0,0v4.9l0,0h-20.4l0,0v-4.9 C803.8,168.3,804.8,167.4,806,167.4C806,167.4,806,167.4,806,167.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_457"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_431",
    className: "st14",
    d: "M750.6,172.7h80.6c0.7,0,1.2,0.5,1.2,1.2v122.9c0,0.7-0.5,1.2-1.2,1.2h-80.6 c-0.7,0-1.2-0.5-1.2-1.2V173.9C749.4,173.2,749.9,172.7,750.6,172.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_432",
    x: 749.4,
    y: 253.4,
    className: "st15",
    width: 83,
    height: 25.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_458"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_433",
    x: 777.7,
    y: 205.9,
    className: "st16",
    width: 44.5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    x: 809.1,
    y: 208.9,
    className: "st10",
    width: 9.9,
    height: 17.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_435",
    x: 781.5,
    y: 208.9,
    className: "st17",
    width: 24.2,
    height: 17.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_460"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    x: 777.7,
    y: 256.2,
    className: "st18",
    width: 20.9,
    height: 19.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_459"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_437",
    x: 780.7,
    y: 258.7,
    className: "st16",
    width: 5.6,
    height: 5.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_438",
    x: 789.5,
    y: 258.7,
    className: "st16",
    width: 5.6,
    height: 5.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_439",
    x: 780.7,
    y: 266.9,
    className: "st16",
    width: 5.6,
    height: 5.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_440",
    x: 789.5,
    y: 266.9,
    className: "st16",
    width: 5.6,
    height: 5.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_441",
    className: "st18",
    d: "M803.5,256.1h6.4c1.2,0,2.1,0.9,2.1,2.1v0.6c0,1.2-0.9,2.1-2.1,2.1h-6.4 c-1.2,0-2.1-0.9-2.1-2.1v-0.6C801.4,257,802.3,256.1,803.5,256.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_442",
    className: "st18",
    d: "M803.5,263.4h6.4c1.2,0,2.1,0.9,2.1,2.1v0.6c0,1.2-0.9,2.1-2.1,2.1h-6.4 c-1.2,0-2.1-0.9-2.1-2.1v-0.6C801.4,264.4,802.3,263.4,803.5,263.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_443",
    className: "st18",
    d: "M803.5,270.7h6.4c1.2,0,2.1,0.9,2.1,2.1v0.6c0,1.2-0.9,2.1-2.1,2.1h-6.4 c-1.2,0-2.1-0.9-2.1-2.1v-0.6C801.4,271.7,802.3,270.7,803.5,270.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_444",
    className: "st16",
    d: "M817.9,255.2h1.3c1.7,0,3.1,1.4,3.1,3.1v16.3c0,1.7-1.4,3.1-3.1,3.1h-1.3 c-1.7,0-3.1-1.4-3.1-3.1v-16.3C814.8,256.5,816.2,255.2,817.9,255.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_445",
    className: "st5",
    d: "M816.8,241.3h3.3l0,0v30.4c0,0.9-0.7,1.7-1.7,1.7l0,0l0,0c-0.9,0-1.7-0.7-1.7-1.7V241.3 L816.8,241.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    className: "st10",
    cx: 818.5,
    cy: 241.1,
    r: 5.7
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    transform: "translate(-596.787 -104.338)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_446",
    x: 694.8,
    y: 228.3,
    className: "st16",
    width: 16,
    height: 111.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    className: "st10",
    cx: 703.4,
    cy: 223.5,
    r: 12.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    className: "st11",
    cx: 703.4,
    cy: 223.5,
    r: 4.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEngineRoom);
export default __webpack_public_path__ + "static/media/img-engine-room.aa535fbea16d3ab45e50645d4f2ffbf8.svg";
export { ForwardRef as ReactComponent };